import { useLayoutEffect, useState } from "react";
import omegaStyle from "./omega.module.css";

import Event from "./event/list";
import EventMaker from "./form/EventMaker";
import Menu from "./menu/menu";

import Notice from "manager/cmath/notice/notice";
import { useLoaderData, useLocation } from "react-router";
import Stat from "./stat/Stat";
import Status from "./status/status"
import { useOffcanvas } from "offcanvas/provider";


export default function Omega() {

    const { offcanvas_close } = useOffcanvas()

    const loaderData = useLoaderData()

    const [branchInfo, Set_branchInfo] = useState({
        'id': "0000",
        'name': "관리",
        'sms': loaderData['SMSUseYN'],
        'smsphone': loaderData['SMSPhone']
    });

	const [selectTab, Set_selectTab] = useState(0);

	const [screenWidth, Set_screenWidth] = useState(window.innerWidth);
	const [screenHeight, Set_screenHeight] = useState(window.innerHeight);

	window.EventManager = {
		branchInfo: branchInfo,
	};

	useLayoutEffect(() => {
		document.body.classList.add(omegaStyle["body"]);

		window.addEventListener("contextmenu", function (e) {
			e.preventDefault();
		});

		window.addEventListener("resize", function () {
			Set_screenWidth(window.innerWidth);
			Set_screenHeight(window.innerHeight);
		});

        window.addEventListener("keydown", function(e) {
            if(e['key'] === 'Escape') {
                offcanvas_close()
            }
        })
	}, []);

	return (
		<div
			className={omegaStyle["omegaWrap"]}
			style={{
				width: screenWidth,
				height: screenHeight,
			}}
		>
			<div className={omegaStyle["leftMenu"]}>
				<Menu selectTab={selectTab} Set_selectTab={Set_selectTab}></Menu>
			</div>

			<div
				className={omegaStyle["contentWrap"]}
				style={{
					display: selectTab === 0 ? "block" : "none",
				}}
			>
				<EventMaker></EventMaker>
			</div>

			<div
				className={omegaStyle["contentWrap"]}
				style={{
					display: selectTab === 1 ? "block" : "none",
				}}
			>
				<div className={omegaStyle["contentTop"]}>
					<Notice></Notice>
				</div>
			</div>

            {selectTab === 2 &&
                <div
                    className={omegaStyle["contentWrap"]}
                    style={{
                        display: selectTab === 2 ? "block" : "none",
                    }}
                >
                    <Stat />
                </div>
            }

            {selectTab === 3 &&
                <div
                    className={omegaStyle["contentWrap"]}
                    style={{
                        display: selectTab === 3 ? "block" : "none",
                    }}
                >
                    <Status />
                </div>
            }
		</div>
	);
}
